import { connect } from 'react-redux';
import { withStyles } from '@mui/styles';
import SubscriptionDetails from './SubscriptionDetails';
import styles from './styles';

function mapStateToProps(state) {
  const { isLoading, data } = state.subscription;
  return {
    isLoading,
    data,
  };
}

const Styled = withStyles(styles)(SubscriptionDetails);

export default connect(
  mapStateToProps,
)(Styled);
